import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '../../../images/chrome-icon.png';
const _hoisted_1 = {
  key: 0,
  class: "content-box p-4 mt-3"
};
const _hoisted_2 = {
  key: 0,
  class: "mt-3 pr-1 pb-6 bg-white relative rounded-lg"
};
const _hoisted_3 = {
  key: 1,
  class: "p-6 bg-white mt-3 rounded-lg"
};
const _hoisted_4 = {
  class: "title text-sm font-semibold leading-5"
};
const _hoisted_5 = {
  class: "mt-3 overflow-y-auto"
};
const _hoisted_6 = ["onClick"];
import { ref, onMounted, computed, onUnmounted, nextTick, inject, toRaw } from 'vue';
import MenuBlock from '@components/MenuBlock.vue';
import { getModelName } from '@views/main/config';
import { htmlParseData, typewriterEffect, findTextMatches } from '@utils/window-helpers';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import ContentBlock from '../components/ContentBlock.vue';
import FoldBox from '../../FoldBox.vue';
import TabBlock from './TabBlock.vue';
import initIncrementalUpdate from '../mixins/incrementalUpdate.mixin';
export default /*@__PURE__*/_defineComponent({
  __name: 'AIScraping',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const {
      messageContentMap,
      incrementalMessageList
    } = storeToRefs(mainStore);
    const foldBoxRef = ref();
    const contentBlockRef = ref();
    const info = ref({});
    const modelVal = ref(''); // 当前选中模型
    const keywordVal = ref(''); // 当前选中咨关键词
    const messageContent = ref([]); // 关键词对应回答结果详情
    const consultingModel = ref(''); // 增量消息推送时的模型
    const consultingKeyword = ref(''); // 增量消息推送时的咨询关键词
    const tabData = ref({}); // 咨询模型下的咨询关键词
    const isCustom = ref(false); // 是否自定义咨询
    const done = ref(false); // 是否完成
    const activeItem = ref({});
    const showModels = computed(() => {
      const models = [];
      Object.values(tabData.value).forEach(item => {
        if (item && item.list.some(x => x.hasContent)) {
          models.push({
            label: item.label,
            value: item.value
          });
        }
      });
      return models;
    });
    const showKeywords = computed(() => {
      const arr = [];
      const item = tabData.value[modelVal.value];
      if (item && item.list) {
        item.list.forEach(x => {
          if (x.hasContent) {
            arr.push({
              label: x.label,
              value: x.value
            });
          }
        });
      }
      return arr;
    });
    const totalNum = computed(() => {
      let num = 0;
      if (info.value.selectionModel) {
        num = info.value.selectionModel.length * info.value.keywords.length;
      }
      return num;
    });
    const showTitle = computed(() => {
      if (done.value || info.value.executeStatus === 3) {
        return `任务4：已完成大模型咨询结果采集，总咨询问题数：【${totalNum.value}】、咨询大模型【${showModels.value.length}】个`;
      }
      const [modelName] = Object.keys(tabData.value);
      const model = getModelName(modelName).label;
      const keyword = tabData.value[modelName]?.list?.[0]?.label || '';
      return `任务4：正在向${consultingModel.value || model} 咨询 ${consultingKeyword.value || keyword} [当前咨询数：
      ${messageContent.value.length || 1}
      总咨询问题数：${totalNum.value}]`;
    });
    const {
      handleIncrementalMessage,
      loadNextMessage
    } = initIncrementalUpdate(async message => {
      if (props.item.id === message.id) {
        const {
          incrementalData
        } = message;
        if (incrementalData.model && incrementalData.data) {
          foldBoxRef.value?.setIsFold(true);
          messageContent.value.push({
            model: incrementalData.model,
            keyword: incrementalData.data.keyword,
            result: incrementalData.data.searchResult,
            brand: incrementalData.data.brand
          });
          consultingModel.value = getModelName(incrementalData.model).label;
          consultingKeyword.value = incrementalData.data.keyword;
          const tabItem = tabData.value[incrementalData.model].list.find(x => x.label === incrementalData.data.keyword);
          if (tabItem) {
            tabItem.hasContent = true;
            tabItem.isAnimate = true;
          }
          if (!isCustom.value) {
            modelVal.value = incrementalData.model;
            keywordVal.value = incrementalData.data.keyword;
            // eslint-disable-next-line no-use-before-define
            setActiveItem();
          }
        }
        done.value = incrementalData.done;
      }
    }, false);
    const handleAnimateEnd = ({
      model,
      keyword
    }) => {
      const tabItem = tabData.value[model]?.list.find(x => x.label === keyword);
      if (tabItem) tabItem.isAnimate = false;
      loadNextMessage();
    };
    let bol = true;
    const setActiveItem = () => {
      const model = modelVal.value;
      const keyword = keywordVal.value;
      if (model && keyword) {
        const item = messageContent.value.find(x => x.model === model && x.keyword === keyword);
        try {
          const tabItem = tabData.value[model].list.find(x => x.label === keyword) || {};
          const obj = {
            ...tabItem,
            ...item,
            content: ''
          };
          if (tabItem.isAnimate) {
            if (!bol) return;
            bol = false;
            let str = '';
            let contentStr = htmlParseData(item.result.html || '', item.model);
            const useText = ['yuanBao', 'wenXin'].includes(item.model);
            if (useText) {
              contentStr = item.result.text;
            }
            contentBlockRef.value?.setCusClass(0);
            typewriterEffect(contentStr, val => {
              str += val;
              item.content = str;
              if (activeItem.value.model === model && activeItem.value.keyword === keyword) {
                if (!useText) {
                  const doc = new DOMParser().parseFromString(str.replace(/<[^>]*$/g, ''), 'text/html');
                  activeItem.value.content = doc.body.innerHTML;
                } else {
                  activeItem.value.content = str;
                }
                contentBlockRef.value?.scrollToBottom();
              }
            }, async () => {
              bol = true;
              item.content = htmlParseData(obj.result.html || '', model) || obj.result.text;
              if (activeItem.value.model === model && activeItem.value.keyword === keyword) {
                contentBlockRef.value.setLoading(true);
                activeItem.value.content = item.content;
                await contentBlockRef.value.beautifyStyle(1);
              }
              if (done.value) {
                mainStore.loadNextMsg(props.item);
                info.value.executeStatus = 3;
              }
              handleAnimateEnd({
                model,
                keyword
              });
            }, 20);
          } else {
            obj.content = item.content;
          }
          activeItem.value = {
            ...tabItem,
            ...item,
            content: obj.content
          };
        } catch (error) {
          if (done.value) {
            mainStore.loadNextMsg(props.item);
            info.value.executeStatus = 3;
          }
          // 处理异常情况
          loadNextMessage();
          activeItem.value = {};
        } finally {
          if (!item.result?.text) {
            // eslint-disable-next-line no-use-before-define
            handleAnimateEnd({
              model,
              keyword
            });
          }
        }
      } else {
        activeItem.value = {};
      }
    };
    const handleClickModel = value => {
      modelVal.value = value;
      if (showKeywords.value.length) {
        keywordVal.value = showKeywords.value[0].value;
      }
      setActiveItem();
    };
    const setTabData = async () => {
      const obj = {};
      if (info.value.selectionModel) {
        info.value.selectionModel.forEach(model => {
          const objItem = {
            label: getModelName(model).label,
            value: model,
            list: []
          };
          info.value.keywords.forEach(keyword => {
            objItem.list.push({
              label: keyword,
              value: keyword,
              hasContent: messageContent.value.some(x => x.model === model && x.keyword === keyword),
              isAnimate: false
            });
          });
          obj[model] = objItem;
        });
      }
      tabData.value = obj;
      await nextTick();
      if (showModels.value.length) {
        modelVal.value = showModels.value[0].value;
        if (showKeywords.value.length) {
          keywordVal.value = showKeywords.value[0].value;
        }
        setActiveItem();
      }
    };
    const openSideEdit = inject('openSideEdit');
    const handleFullScreen = () => {
      openSideEdit({
        type: 'view_scraping',
        title: 'AI咨询结果',
        typeQuery: {
          activeModel: modelVal.value,
          activeKeyword: keywordVal.value
        },
        contentData: {
          messageContent: toRaw(messageContent.value),
          tabData: toRaw(tabData.value),
          showModels: toRaw(showModels.value),
          showKeywords: toRaw(showKeywords.value)
        }
      });
    };
    const safeJsonParse = str => {
      try {
        return JSON.parse(str);
      } catch {
        // 尝试修复缺少闭合括号的截断 JSON
        let fixed = str;
        const open = (str.match(/{/g) || []).length;
        const close = (str.match(/}/g) || []).length;
        if (open > close) {
          fixed += '}'.repeat(open - close);
        }
        try {
          return JSON.parse(fixed);
        } catch {
          console.warn('JSON repair failed, raw string:', str.substring(0, 100));
          return {
            html: '',
            text: str,
            brands: []
          };
        }
      }
    };
    const parseData = arr => {
      const newArr = [];
      arr.forEach(x => {
        try {
          const obj = {
            ...x,
            result: typeof x?.result === 'string' ? safeJsonParse(x.result) : x.result
          };
          obj.content = htmlParseData(obj.result?.html || '', obj.model) || obj.result?.text || '';
          newArr.push(obj);
        } catch (error) {
          console.warn('parseData item error:', error);
        }
      });
      return newArr;
    };
    const handleClickBrand = brand => {
      const scrollEl = contentBlockRef.value.getScrollEl();
      findTextMatches(brand, scrollEl);
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        if (props.content) info.value = props.content;
        // 保证使用数据的指向是同一个数据源
        messageContentMap.value[props.item.id] = parseData(messageContentMap.value[props.item.id] || []);
        messageContent.value = messageContentMap.value[props.item.id] || [];
        setTabData(); // 设置初始化数据
        // 处理增量数据
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
      } catch (error) {
        info.value = {};
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_full = _resolveComponent("i-home-full");
      return _openBlock(), _createBlock(FoldBox, {
        ref_key: "foldBoxRef",
        ref: foldBoxRef,
        id: props.item.id,
        status: info.value.executeStatus || 1
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(showTitle.value), 1)]),
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "tool-block pl-3 py-[10px]"
        }, [_createElementVNode("div", {
          class: "flex items-center"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: "chrome",
          class: "w-5 h-5"
        }), _createElementVNode("div", {
          class: "ml-1 text-[#4E5969] text-sm"
        }, "正在使用浏览器工具：Chrome Tools")])], -1)), showModels.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(TabBlock, {
          tabs: showModels.value,
          class: "mb-3",
          modelValue: modelVal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => modelVal.value = $event),
          onChange: handleClickModel
        }, null, 8, ["tabs", "modelValue"]), _createVNode(MenuBlock, {
          list: showKeywords.value,
          modelValue: keywordVal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => keywordVal.value = $event),
          onChange: setActiveItem
        }, null, 8, ["list", "modelValue"]), activeItem.value.result ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(ContentBlock, {
          ref_key: "contentBlockRef",
          ref: contentBlockRef,
          content: activeItem.value.content,
          cusSty: !__props.item.openAnimate ? 1 : undefined,
          height: "400px"
        }, null, 8, ["content", "cusSty"]), !activeItem.value.isAnimate ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "btn-box",
          onClick: handleFullScreen
        }, [_createVNode(_component_i_home_full, {
          class: "w-2 h-2"
        }), _cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "ml-1"
        }, "全屏查看/预览", -1))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeItem.value.result && activeItem.value.result.brands ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, " 累计发现品牌（" + _toDisplayString(activeItem.value.result.brands.length) + "） ", 1), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeItem.value.result.brands, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "inline-flex items-center justify-center brand-item",
            onClick: $event => handleClickBrand(item)
          }, _toDisplayString(item), 9, _hoisted_6);
        }), 128))])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["id", "status"]);
    };
  }
});